import {Req} from 'quickstart/types'
import {MetaProps} from 'quickstart/utils'
import {logger} from 'tizra'
import * as B from '../block'
import {Config} from './admin'

const log = logger('HeaderBlock')

type TitleProps = Pick<
  Config,
  | 'alignment'
  | 'callsToAction'
  | 'headingProp'
  | 'otherProps'
  | 'subHeadingProp'
> &
  Req<MetaProps, 'metaType' | 'tizraId'> & {
    singleColumn: boolean
  }

export const Title = ({
  alignment,
  callsToAction,
  headingProp,
  otherProps,
  singleColumn,
  subHeadingProp,
  ...metaProps
}: TitleProps) => {
  return (
    <B.Stack alignItems={B.flexAlign(alignment)} wrapChildren={false}>
      <B.MetaValue
        as={B.H1}
        prop={headingProp}
        style={{
          textAlign: alignment,
          // @ts-expect-error huh
          textWrap: 'balance',
        }}
        {...metaProps}
      />
      <B.MetaValue
        as={B.Text}
        prop={subHeadingProp}
        textAlign={alignment}
        textWrap="balance"
        {...metaProps}
      />
      <B.MetaList propNames={otherProps} textAlign={alignment} {...metaProps} />
    </B.Stack>
  )
}

Title.displayName = 'HeaderBlock.Title'
